module.exports = __webpack_public_path__ + "static/media/Sanitär.5f82c6b7.jpg";